export default {"src":"/_next/static/media/missed_frame.0298a2f7.svg","height":39,"width":98,"blurWidth":0,"blurHeight":0};